export default "__VITE_ASSET__c8691646__"